const Job = [
    { id: 60,
     name: 'Belum Bekerja'
    },
    { id: 61,
     name: 'Wiraswasta'
    },
    { id: 62,
     name: 'Bekerja'
    }
]

const getJobByName = (name) => {
    if(!name){
        return 1
    }
    const gender = Job.filter(data => data.name === name.toUpperCase())

    if(gender.length === 0){
        return 1
    }

    return gender[0].id
}

const getJobName = (id) => {
    if(!id){
        return 'NONE'
    }
    const gender = Job.filter(data => data.id === id)
    return gender[0].name
}



export {
    Job,
    getJobName,
    getJobByName
}
